const redux = require('redux');
const combineReducers = redux.combineReducers;
let initialState = {
    authenticated: false,
    shoppingList: [],
    favoriteStores: [],
    signInModal: false,
    signInFromHeader: false,
    mapLoading: false,
};
export default function reducers(state = initialState, action) {
    switch (action.type) {
        case 'INCREMENT_LIST':
            return Object.assign(Object.assign({}, state), { shoppingList: [...state.shoppingList, action.liquor] });
        case 'DECREMENT_LIST':
            return Object.assign(Object.assign({}, state), { shoppingList: state.shoppingList
                    .filter((x) => { return x !== action.liquor; }) });
        case 'GET_LIST':
            return Object.assign(Object.assign({}, state), { shoppingList: action.slist.split(',').map((x) => { return parseInt(x); }) });
        case 'INCREMENT_FAVORITE':
            return Object.assign(Object.assign({}, state), { favoriteStores: [...state.favoriteStores, action.store] });
        case 'DECREMENT_FAVORITE':
            return Object.assign(Object.assign({}, state), { favoriteStores: state.favoriteStores
                    .filter((x) => { return x !== action.store; }) });
        case 'GET_FAVORITE':
            return Object.assign(Object.assign({}, state), { favoriteStores: action.flist.split(',').map((x) => { return parseInt(x); }) });
        case 'SET_AUTH':
            return Object.assign(Object.assign({}, state), { authenticated: action.login });
        case 'TOGGLE_LOGIN':
            return Object.assign(Object.assign({}, state), { signInModal: !state.signInModal, signInFromHeader: false });
        case 'TOGGLE_LOGIN_HEADER':
            return Object.assign(Object.assign({}, state), { signInModal: !state.signInModal, signInFromHeader: !state.signInModal });
        case 'TOGGLE_LOADING':
            return Object.assign(Object.assign({}, state), { mapLoading: !state.mapLoading });
        default:
            return state;
    }
}
//# sourceMappingURL=index.js.map